/** "tenant/account" of the administrator's own trading accounts, from its scopes. */
import { useScopes } from "@/shared/session/scopes";

export function useOwnAccountKeys(): ReadonlySet<string> {
  const scopes = useScopes();
  return new Set(
    scopes.filter((option) => option.kind === "ACCOUNT").map((option) => `${String(option.tenant_id)}/${String(option.account_id)}`),
  );
}
